import React, { useEffect } from 'react';
import { animateScroll as scroll } from 'react-scroll/modules';

import { StringKeyValue } from '../../../actions/types';
import KycForm from '../../../components/Kyc/KycForm';
import Loader from '../../../components/Loader/Loader';
import { LoaderReducer } from '../../../reducers/loader';

interface Props {
    ssn: string;
    previousEvent: () => void;
    completeEvent: (status: string) => void;
    text: StringKeyValue;
    loader: LoaderReducer;
}

const LoanApplicantMainKyc = ({ ssn, previousEvent, completeEvent, text, loader }: Props): JSX.Element => {
    useEffect(() => {
        setTimeout(() => {
            scroll.scrollToTop();
        }, 200);
    }, []);
    if (loader.isUpdatingApplication) return <Loader title={text.loadingDefault} />;
    return (
        <div className="kyc">
            <KycForm ssn={ssn} previousEvent={() => previousEvent()} completeEvent={completeEvent} />
        </div>
    );
};

export default LoanApplicantMainKyc;
